<template>
    <div id="video-container">
        <div class="describe-group">
            <p class="notice">请录制视频朗读或随机描述一段文字：</p>
            <el-card class="box-card">
                <p class="detail">
                    普通能力测试主要包括思维能力、想象能力、记忆能力、推理能力、分析能力、数学能力、空间关系判断能力、语言能力等方面的测试。
                </p>
            </el-card>

        </div>
        <div class="face-video" id="face-video">
            <p class="tip">请保持面部在取景框内</p>
            <video :height="vheight" :width="vwidth" id="video" playsinline webkit-playsinline></video>
<!--            <video id="videoPreview" width="200" height="200" autoplay></video> -->
<!--             <button>-->
<!--                <a :href="downloadLink" download="RecordedVideo.webm">download</a>-->
<!--             </button>   -->
            <canvas :height="cheight" :width="cwidth" id="refCanvas"></canvas>
            <!--            <img alt="" class="img-cover" src="../assets/cryscore.png"/>-->
            <p class="contentp">{{ scanTip }}</p>
        </div>
           
        <div class="button-group" v-if="tipFlag">
            <el-button type="primary" @click="onStartRecording" :disabled="!stopped">开始录制</el-button>
            <el-button type="danger" @click="stopRecording">停止录制</el-button>
        </div>
        <div class="submit" v-if="videoGot">
            <el-button type="success" @click="uploadRecord" :loading="submitFlag">提交</el-button>
        </div>
<!--        <div class="submit" v-if="tipFlag">-->
<!--            <el-button type="success" @click="debug">Skip</el-button>-->
<!--        </div>-->

    </div>
</template>

<script>
    import api from '@/api/index'
    require('tracking/build/tracking-min.js');
    require('tracking/build/data/face-min.js');
    require('tracking/build/data/eye-min.js');
    require('tracking/build/data/mouth-min.js');
    export default {
        name: "Video",
        data() {
            return {
                screenSize: {
                    width: window.screen.width,
                    height: window.screen.height,
                },
                URL: null,
                streamIns: null, // 视频流
                showContainer: true, // 显示
                tracker: null,
                tipFlag: false, // 提示用户已经检测到
                flag: false, // 判断是否开始录制
                context: null, // canvas上下文
                profile: [], // 轮廓
                removePhotoID: null, // 停止转换图片
                scanTip: "面部检测中...", // 提示文字
                imgUrl: "",
                canvas: null,
                trackertask: null,
                vwidth: "266",
                vheight: "266",
                cwidth: "266",
                cheight: "266",
                userInfo: {},
                orderData: {},
                shouldStop: false,
                stopped: true,
                downloadLink: '',
                videoGot:false,
                videoTime:0,
                videoData:null,
                submitFlag:false
            };
        },
        mounted() {
            //设置video canvas宽高
            const scale = this.screenSize.width / 375 *0.6;
            this.vwidth = 266 * scale;
            this.vheight = 266 * scale;
            this.cwidth = 266 * scale;
            this.cheight = 266 * scale;
            this.playVideo();
        },
        methods: {
            debug(){
                this.$router.push('/score')
            },
            playVideo() {
                this.getUserMedia(
                    { //摄像头拍摄的区域
                        video: {
                            width: 500,
                            height: 500,
                            facingMode: "user",
                        } /* 前置优先 */,
                        audio: true,     //开启音频
                    },
                    this.success,
                    this.error
                );
            },
            // 访问用户媒体设备
            getUserMedia(constrains, success, error) {
                if (navigator.mediaDevices.getUserMedia) {
                    //最新标准API
                    navigator.mediaDevices
                        .getUserMedia(constrains)
                        .then(success)
                        .catch(error);
                } else if (navigator.webkitGetUserMedia) {
                    //webkit内核浏览器
                    navigator.webkitGetUserMedia(constrains).then(success).catch(error);
                } else if (navigator.mozGetUserMedia) {
                    //Firefox浏览器
                    navagator.mozGetUserMedia(constrains).then(success).catch(error);
                } else if (navigator.getUserMedia) {
                    //旧版API
                    navigator.getUserMedia(constrains).then(success).catch(error);
                } else {
                    this.scanTip = "你的浏览器不支持访问用户媒体设备";
                }
            },
            success(stream) {
                this.streamIns = stream;
                const video = document.getElementById("video");
                // webkit内核浏览器
                this.URL = window.URL || window.webkitURL;
                if ("srcObject" in video) {
                    video.srcObject = stream;
                } else {
                    video.src = this.URL.createObjectURL(stream);
                }
                // 苹果手机的系统弹框会阻止js的线程的继续执行 手动0.1秒之后自动执行代码
                setTimeout(() => {
                    video.play();
                    this.initTracker();// 人脸捕捉
                }, 100);
            },
            error(e) {
                this.scanTip = "访问用户媒体被拒绝，请重试或更换浏览器";
            },
            initTracker() {
                this.context = document.getElementById("refCanvas").getContext("2d"); // 画布
                this.canvas = document.getElementById("refCanvas");
                this.tracker = new window.tracking.ObjectTracker("face"); // tracker实例
                this.tracker.setInitialScale(4);
                this.tracker.setStepSize(2); // 设置步长
                this.tracker.setEdgesDensity(0.1);
                try {
                    this.trackertask = window.tracking.track("#video", this.tracker); // 开始追踪
                } catch (e) {
                    this.scanTip = "访问用户媒体失败，请重试";
                }
                //开始捕捉方法 一直不停的检测人脸直到检测到人脸
                this.tracker.on("track", (e) => {
                    //画布描绘之前清空画布
                    this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
                    if (!this.tipFlag && e.data.length === 0) {
                        this.scanTip = "未识别到面部";
                    } else {
                        e.data.forEach((rect) => {
                            //设置canvas 方框的颜色大小
                            this.context.strokeStyle = "#42e365";
                            this.context.lineWidth = 2;
                            this.context.strokeRect(rect.x, rect.y, rect.width, rect.height);
                        });
                        if (!this.tipFlag) {
                            this.scanTip = "识别成功,可以录制";
                        }
                        // falg 限制一直捕捉人脸，只要录制之后就停止检测
                        if (!this.flag) {
                            this.flag = true;
                            this.removePhotoID = setTimeout(() => {
                                this.tipFlag = true;
                            }, 1500);
                        }
                    }
                });
            },
            close() {
                this.flag = false;
                this.tipFlag = false;
                this.showContainer = false;
                this.submitFlag=false;
                this.context = null;
                this.scanTip = "面部检测中...";
                clearTimeout(this.removePhotoID);
                if (this.streamIns) {
                    this.streamIns.enabled = false;
                    this.streamIns.getTracks()[0].stop();
                    this.streamIns.getVideoTracks()[0].stop();
                }
                this.streamIns = null;
                this.trackertask.stop();
                this.tracker = null;
            },
            onStartRecording() {
                this.flag = true;
                this.shouldStop = false;
                this.stopped = false;
                this.scanTip = "录制开始...";
                const optionsRecorder = {
                    mimeType: 'video/webm',
                };
                const recordedChunks = [];
                const video = document.getElementById("video");
                // const videoReproduce = document.getElementById("videoPreview");
                const mediaRecorder = new MediaRecorder(video.srcObject, optionsRecorder);
                var counter = 0;
                mediaRecorder.addEventListener('dataavailable', (e) => {
                    if (e.data.size > 0) {
                        console.log('recording...');
                        recordedChunks.push(e.data);
                        counter+=1;
                        this.scanTip = "录制中... "+counter.toString()+"s";
                    }
                    if (this.shouldStop && !this.stopped) {
                        mediaRecorder.stop();
                        this.stopped = true;
                        this.scanTip = "录制停止";
                        this.videoTime = counter;
                    }else{
                        if (counter>25){
                            mediaRecorder.stop();
                        this.stopped = true;
                        this.scanTip = "录制超时自动停止";
                        this.videoTime = counter;
                        }
                    }
                })
                mediaRecorder.addEventListener('stop', () => {
                    this.videoData = new Blob(recordedChunks);
                    // this.downloadLink = URL.createObjectURL(this.videoData);
                    // videoReproduce.src = this.downloadLink;
                    //判断视频是否符合
                    if (this.videoData.size>100 && counter>6){
                        this.videoGot = true;
                        this.scanTip = "录制成功";
                    } else{
                        this.scanTip = "录制失败";
                        this.videoGot = false;
                    }
                });
                mediaRecorder.start(1000);
                // console.log(mediaRecorder);
            },
            //停止录像触发
            stopRecording() {
                this.shouldStop = true;
            },
            uploadRecord() {
                this.submitFlag=true;
                var that = this;
                var data = new FormData();

                document.getElementById("video").pause();
                data.append('uid',this.$store.state.uid);
                // console.log( this.videoData);
                data.append('webmasterfile', this.videoData);
                // console.log(data);
                this.$http.post(api.UploadVideo,data).then(function (res) {
                    console.log(res.status);
                    if (res.data.msg === false) {
                        alert('提交失败请重试')
                    } else {
                        alert('提交成功');
                        that.close();
                        that.$router.push('/score')
                    }
                    });
                // this.close();
            }
        }
    }
</script>

<style scoped>
    .face-video {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .describe-group{
        margin-top: 4rem;
        margin-bottom: 2rem;
        display: flex;
    }
    .notice{
        position: fixed;
        top: 6rem;
        margin: 0 1rem;
        font-size: 1.6rem;
    }
    .detail{
        font-size: 1.5rem;
        color: #409EFF;
        font-weight: 500;
    }

    .el-card {
        min-height: 10rem;
    }

    .tip {
        position: fixed;
        z-index: 5;
        font-size: 1.5rem;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #F56C6C;
        line-height: 2.5rem;
    }

    .face-video video,
    .face-video canvas {
        position: fixed;
        margin-top: 10rem;
        object-fit: cover;
        z-index: 2;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .face-video .img-cover {
        position: fixed;
        top: 6.3rem;
        width: 37.5rem;
        height: 37.5rem;
        object-fit: cover;
        z-index: 3;
        background-repeat: no-repeat;
        background-size: 100% 100%;
    }

    .face-video .contentp {
        position: fixed;
        top: 42rem;
        font-size: 1.8rem;
        font-weight: 500;
        color: #333333;
    }

    .face-video .rect {
        border: 0.2rem solid #0aeb08;
        position: fixed;
        z-index: 4;
    }

    .img-face {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    .img-face .imgurl {
        position: fixed;
        top: 11.75rem;
        width: 26.6rem;
        height: 26.6rem;
        border-radius: 13.3rem;
    }
    .button-group{
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 25rem;
    }
    .submit{
        margin: 2rem 0;
        display: flex;
        justify-content: center;
    }
    .submit button {
        width: 15rem;
    }
</style>